import { AudioFileAvailabilityFragment } from '~/graphqlTypes/AudioFileAvailabilityFragment';
import { CountryAvailabilityFragment } from '~/graphqlTypes/CountryAvailabilityFragment';
import { CountryInclusionMode } from '~/graphqlTypes/globalTypes';
import { useAsyncModal } from '~/hooks/useAsyncModal';
import * as UseAsyncModal from '~/hooks/useAsyncModal';

type ModelType = AudioFileAvailabilityFragment;

function isCountryAvailabilityComplete(
  countryAvailability: Partial<CountryAvailabilityFragment>,
): countryAvailability is CountryAvailabilityFragment {
  const { mode, countriesAndDates: countries } = countryAvailability;

  return (
    ( countries && countries.length > 0 ) ||
    mode === CountryInclusionMode.include_all ||
    mode === CountryInclusionMode.exclude_all // not an option at present, but adding it anyway.
  );
}

function isModelComplete( model?: Partial<ModelType> ): model is ModelType {
  return (
    model !== undefined &&
    model.streamingRights !== undefined &&
    model.countryAvailability !== undefined &&
    isCountryAvailabilityComplete( model.countryAvailability )
  );
}

export function useAudioFileAvailabilityModal(): UseAsyncModal.AsyncModal<ModelType> {
  const { show: baseShow, showing, controls } = useAsyncModal<ModelType>();

  const show = ( config: UseAsyncModal.Configuration<ModelType> ) =>
    baseShow( {
      isModelComplete,
      ...config,
    } );

  return showing ? { show, showing, controls } : { show, showing };
}
